// extracted by mini-css-extract-plugin
export default {"flag":"flag-vlUb_Hpo","clickable":"clickable-i9XRDlcl","storybookFlag":"storybookFlag-Hlzh63H2"};